import { useLocale } from '@solinkcorp/locale';
import { SimpleFormField } from '@solinkcorp/solink-ui/components/Form';
import { NumberInputGroup } from '@solinkcorp/solink-ui/components/NumberInputGroup';
import { Label } from '@solinkcorp/solink-ui/components/ui/label';
import React from 'react';
import { type UseFormReturn } from 'react-hook-form';
import { type WidgetFormData } from './schema';

interface DurationThresholdFieldsProps {
  form: UseFormReturn<WidgetFormData>;
  helperText?: string;
}

/**
 * The "Default Threshold" minutes/seconds pair, shared by the time and total-journey-time
 * widgets since both designs render it identically.
 */
export const DurationThresholdFields: React.FC<DurationThresholdFieldsProps> = ({
  form,
  helperText,
}) => {
  const locale = useLocale();

  return (
    <div className="flex w-full flex-col gap-1">
      <div className="flex w-full items-start gap-1">
        <SimpleFormField
          className="w-24"
          control={form.control}
          name="timeThresholdMinutes"
          label={
            <span className="w-0 min-w-0 whitespace-nowrap">
              {locale.serviceDisplayMonitor.defaultThreshold}
            </span>
          }
          render={({ field }) => (
            <NumberInputGroup
              placeholder="0"
              min={0}
              value={field.value}
              defaultValue={0}
              onChange={(value) => field.onChange(value)}
              suffix="min"
            />
          )}
        />

        <div className="grid gap-2" aria-hidden>
          <Label>{' '}</Label>
          <span className="flex min-h-9 items-center text-sm text-text-primary">:</span>
        </div>

        <SimpleFormField
          className="w-24"
          control={form.control}
          name="timeThresholdSeconds"
          label={' '}
          render={({ field }) => (
            <NumberInputGroup
              placeholder="0"
              min={0}
              max={59}
              defaultValue={0}
              value={field.value}
              onChange={(value) => field.onChange(value)}
              suffix="sec"
            />
          )}
        />
      </div>

      {helperText && <p className="m-0 text-text-secondary caption">{helperText}</p>}
    </div>
  );
};
